import { useEffect } from "react";
import { useParams,useNavigate } from "react-router";
import {Row,Col} from "react-bootstrap";
import log from '../../../sitel/commons/services/log';
import authCentral from '../../../services/authCentral';
import { PageCardWrapper} from '../../../sitel/demon/ui/atoms';
import { useBaseUrlCreateFlow } from "../../../services/urlServices";


export default function Step4VerifyCode(){
    const code = useParams().sg1code || false;
    const {medstarAssociationType} = useParams();
    const baseUrl = useBaseUrlCreateFlow();
    const navigate = useNavigate();

    useEffect(() => {
        async function startAuthFlow(){
          log.debug(`starting sg1 authentication flow with code ${code}`);
          const success = await authCentral.loadJWTFromServer(`sg1-${code}`,`&medstar-association-type=${medstarAssociationType}`);
        
          //depends on your logic, redirect to the next step/url
          if(success && authCentral.getCurrentUser()){
            log.debug('LOGGED IN',success,`${baseUrl}/step5/profile`);
            navigate(`${baseUrl}/step5/profile`);
          } else {//Either code is incorrect or it timedout. User needs to start process from begining 
            navigate(`${baseUrl}/step2/credentials?error=badcode`);
          }
        }

        if(code){        
          startAuthFlow();
        }
      },[code,medstarAssociationType,navigate,baseUrl] );
    
    return (
        <PageCardWrapper title="Verifying your email address">
          <Row>
            <Col className="m-3" md={6}>
                <h2>Please wait...</h2>
            </Col>
          </Row>
        </PageCardWrapper>
    );
}
